import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { hasActiveSession, clearSessionStorage } from '@auth/utils/session';
import { AuthService } from '@auth/data-access/auth.service';

export const accesoAppGuard: CanActivateFn = (route, state) => {

  const router = inject(Router)
  const authService = inject(AuthService)

  if (!hasActiveSession()) {
    router.navigate(['/login'])
    return false
  }

  return authService.validateToken().pipe(
    map(() => true),
    catchError(() => {
      clearSessionStorage()
      router.navigate(['/login'])
      return of(false)
    })
  )
}
